import { cn } from '@/context/global/utils/cn';
import { ButtonHTMLAttributes } from 'react';

type ButtonKaraokeProps = ButtonHTMLAttributes<HTMLButtonElement>;

const ButtonKaraoke = ({
  className,
  children,
  disabled,
  ...props
}: ButtonKaraokeProps) => {
  return (
    <button
      {...props}
      disabled={disabled}
      className={cn(
        'transform cursor-pointer rounded-full border border-[#FFFFFF10] bg-[#00000040] p-[15px] transition-all hover:scale-110 hover:border hover:border-white',
        disabled && 'cursor-not-allowed opacity-40 hover:scale-100 hover:border-[#FFFFFF10]',
        className,
      )}
    >
      {children}
    </button>
  );
};

export default ButtonKaraoke;
